// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { add16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-add': IconAdd;
    }
}

/**
 * The icon component for the 'add' icon
 */
export class IconAdd extends Icon {
    public constructor() {
        super(add16X16);
    }
}

registerIcon('icon-add', IconAdd);
export const iconAddTag = 'nimble-icon-add';
